import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { WarningModalComponent } from '@app/@shared/components/warning-modal/warning-modal.component';
import { DialogService } from '@app/@shared/services/dialog/dialog.service';
import { EntitlementService } from '@app/@shared/services/entitlement/entitlement.service';
import { NavigationService } from '@app/@shared/services/navigation/navigation.service';

@Component({
  selector: 'app-non-entitled-prompt',
  templateUrl: './non-entitled-prompt.component.html',
  styleUrls: ['./non-entitled-prompt.component.scss']
})
export class NonEntitledPromptComponent {
  @Input() channelNames: string;
  @Input() subscriptionId: string;
  @Input() requestAccessDialogString: string;

  constructor(
    private router: Router,
    private navService: NavigationService,
    private dialogService: DialogService,
    private entitlementService: EntitlementService,
  ) {}

  onClickPVO() {
    const modalInstance = this.dialogService.open(WarningModalComponent, {
      size: 'sm',
      centered: true,
      windowClass: 'uui-modal',
    });
    modalInstance.componentInstance.props = {
      title: 'Access this report as part of a subscription',
      bodyTitle: 'Benefits of a subscription:',
      bodyList: [
        'Access to industry leading analysts',
        'Both current and historical repository of research',
        'Timely updates to forecasts, market share, market sizing, trends and more',
      ],
      closeButtonLabel: 'Close',
      actionButtonLabel: 'View Product Overview',
    };
    modalInstance.result.then(() => {
      let url = 'https://www.techinsights.com/technology-professional';
      if (!this.subscriptionId) {
        window.open(url);
        return;
      }

      this.navService.getProductOverviewPath(this.subscriptionId).subscribe((result) => {
        if(!result || result.length <= 0) {
          window.open(url);
          return;
        }
        this.router.navigate(result);
      })
    });
  }

  onClickRequest() {
      this.entitlementService.openRequestAccessFormDialog(this.requestAccessDialogString);
  }
}
